import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { withIntl } from 'ha/i18n';

import { getCollectionFilter, getCityName } from '../selectors';

import SearchCollectionSubtitle from '../components/SearchCollectionSubtitle';

const enhance = compose(
  connect(
    createStructuredSelector({
      canonicalCollection: getCollectionFilter,
      city: getCityName,
    }),
  ),
  withIntl,
);

export default enhance(SearchCollectionSubtitle);
